/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Design_Settings_PreviewInputs */

const en_admin_design_settings_preview = /** @type {(inputs: Admin_Design_Settings_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preview:`)
};

const de_admin_design_settings_preview = /** @type {(inputs: Admin_Design_Settings_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorschau:`)
};

/**
* | output |
* | --- |
* | "Preview:" |
*
* @param {Admin_Design_Settings_PreviewInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_design_settings_preview = /** @type {((inputs?: Admin_Design_Settings_PreviewInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Design_Settings_PreviewInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_design_settings_preview(inputs)
	return en_admin_design_settings_preview(inputs)
});